import React from 'react';
import testimonialImage from '../../static/images/dusting.jpg';

const TestimonialSection = () => {
    return (
        <section className="testimonial-section">
            <div className="testimonial-container">
                <div className="testimonial-image">
                    <img src={testimonialImage} alt="Testimonial" />
                </div>
                <div className="testimonial-content">
                    <p className="testimonial-quote">
                        “Nectr Studio made our website launch effortless. The new site is fast, modern, and easy for our team to manage. Communication was clear, and every step was handled professionally. Highly recommend for any restaurant or bar looking to upgrade their online presence.”
                    </p>
                    <div className="testimonial-logo">
                        {/*<img src="/path/to/logo.svg" alt="Logo" />*/}
                        <div>
                            {/*<h2>360LAB</h2>*/}
                            <p className="testimonial-subtext">Jordan Avery<br /><span>Owner, The Willow Room</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialSection;
